import CreateWidgetModal from './CreateWidgetModal';

export default CreateWidgetModal;
